import styled from "@emotion/styled";
import { IconButton, Tooltip } from "@mui/material";
import { NavLink } from "react-router-dom";
import SideTabIcon from "./SideTabIcon";
import { CDashboardModuleTab } from "../../types";

const TabWrapper = styled(NavLink)`
	height: 27px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-content: center;
	color: #374151;
	padding: 10px 0;
	text-decoration: none;

	&.active {
		background-color: #2b3851;
		.MuiIcon-root {
			color: #319af6 !important;
		}
	}

	&:hover {
		background-color: #402aa4;
	}

	img {
		width: 24px;
		height: 24px;
	}
`;

const TabActionWrapper = styled(IconButton)`
	height: 50px;
	border-radius: 0px;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	align-content: center;
	color: #374151;
	padding: 10px 0;
	text-decoration: none;

	&.active {
		background-color: #2b3851;
		.MuiIcon-root {
			color: #319af6 !important;
		}
	}

	&:hover {
		background-color: #402aa4;
	}

	img {
		width: 24px;
		height: 24px;
	}
`;

export interface PanelTabProps {
	title: string;
	icon: string;
	path?: string;
	onClick?: () => void;
}

const PanelTab: React.FC<PanelTabProps> = ({ title, icon, path, onClick }) => {
	return (
		<Tooltip title={title} arrow placement="right">
			<span>
				{path && (
					<TabWrapper to={`${path}`}>
						<SideTabIcon icon={icon} />
					</TabWrapper>
				)}
				{onClick && (
					<TabActionWrapper onClick={onClick}>
						<SideTabIcon icon={icon} />
					</TabActionWrapper>
				)}
			</span>
		</Tooltip>
	);
};

export default PanelTab;
